export const FILTER_EDITOR_LOCALE_ZHCHS = {
    // åæ¶
    cancelButton: 'åæ¶',
    // ç¡®å®
    okButton: 'ç¡®å®',
    // æ·»å å­å¥
    addWhere: 'æ·»å å­å¥',
    clear: 'æ¸ç©º',
    // ç½®é¡¶
    moveTop: 'ç½®é¡¶',
    // ä¸ç§»
    moveUp: 'ä¸ç§»',
    // ä¸ç§»
    moveDown: 'ä¸ç§»',
    // ç½®åº
    moveBottom: 'ç½®åº',
    // å·¦æ¬å·
    leftBrackets: 'å·¦æ¬å·',
    // å­æ®µ
    field: 'å­æ®µ',
    // æä½ç¬¦
    operator: 'æä½ç¬¦',
    // å¼
    value: 'å¼',
    // å¼ç±»å
    valueType: 'å¼ç±»å',
    expressType: {
        value: 'å¼',
        express: 'è¡¨è¾¾å¼',
        frontExpress: 'è¡¨åè¡¨è¾¾å¼'
    },
    // å³æ¬å·
    rightBrackets: 'å³æ¬å·',
    // å³ç³»
    relation: 'å³ç³»',
    relationValue: {
        and: 'å¹¶ä¸',
        or: 'æè'
    },
    designTab: 'è®¾è®¡å¨',
    jsonTab: 'æºä»£ç ',
    sqlTab: 'Sqlé¢è§',
    title: 'æ¡ä»¶ç¼è¾å¨',
    message: 'ç¡®è®¤è¦æ¸ç©ºå½åæææ°æ®åï¼',
    validate: {
        bracket: 'å·¦å³æ¬å·ä¸å¹éï¼è¯·æ£æ¥',
        relation: 'æ¡ä»¶å³ç³»ä¸å®æ´ï¼è¯·æ£æ¥',
        field: 'æ¡ä»¶å­æ®µæªè®¾ç½®ï¼è¯·æ£æ¥'
    }
};

export const ENUM_EDITOR_LOCALE_ZHCHS = {
    // åæ¶
    cancelButton: 'åæ¶',
    // ç¡®å®
    okButton: 'ç¡®å®',
    // æ·»å å­å¥
    addWhere: 'æ·»å ',
    clear: 'æ¸ç©º',
    // ç½®é¡¶
    moveTop: 'ç½®é¡¶',
    // ä¸ç§»
    moveUp: 'ä¸ç§»',
    // ä¸ç§»
    moveDown: 'ä¸ç§»',
    // ç½®åº
    moveBottom: 'ç½®åº',

    remove: 'å é¤',

    title: 'æä¸¾æ°æ®ç¼è¾å¨',
    message: 'ç¡®è®¤è¦æ¸ç©ºå½åæææ°æ®åï¼',
    value: 'å¼',
    name: 'åç§°'
};

